var React = require('react');

function SwiperNext (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.66699 7L0.466993 0.0717923L0.466992 13.9282L7.66699 7Z","fill":"#30353F"}));
}

SwiperNext.defaultProps = {"width":"8","height":"14","viewBox":"0 0 8 14","fill":"none"};

module.exports = SwiperNext;

SwiperNext.default = SwiperNext;
